const animations = require('./animations');

const header = () => {

    $(".header-menu .navbar-toggler-icon").click(function () {
        if ($(this).hasClass("searching-toggler")) return;
        $(".header-menu .menu.mb-show").fadeToggle();
        animations();
    });

    $(window).on("scroll", function () {
        const $header = $(".header-menu");
        if (!$header.length) return;

        const isOnTop = $(window).scrollTop() >= $header.offset().top;
        if (isOnTop) $header.addClass("fixed")
        else $header.removeClass("fixed")
    });
    $(document).on("click", ".searching-toggler .icon-search, .searching-toggler.close-search .close, .searching-toggler.mb, .navbar-toggler .searching-toggler.close", function () {

        let isSearching = $(".search-container").hasClass("active");
        $(".search-container").toggleClass("active");
        $(".header-menu .menu").toggleClass("searching");
        if (!isSearching) {
            $("html, body").animate({
                scrollTop: $(".search-container").offset().top - 100
            }, 500,
                function () {
                        $(".input-search input").trigger("focus")
                }
            );
        }

        //mobile
        $(".header-menu .navbar-toggler .navbar-toggler-icon").toggleClass("close").toggleClass("searching-toggler")
        if (!isSearching) {
            $(".header-menu .menu.mb-show").fadeToggle();
        }
    })
}

module.exports = header
